// dev-portal/src/utils/PublicRoute.js

import { Navigate, useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export default function PublicRoute({ children }) {
    const location = useLocation();
    const token = useMemo(() => localStorage.getItem('token'), []);
    // An invite link carries its own token in the URL - always let it through
    // to the signup page, even if this browser already has an active session.
    const hasInviteToken = useMemo(
        () => new URLSearchParams(location.search).has('token'),
        [location.search]
    );

    // If user is logged in, redirect them to appropriate dashboard
    if (token && !hasInviteToken) {
        // You need to get the user's role from somewhere, e.g., localStorage or context
        const role = localStorage.getItem('role');
        let dashboardPath = '/dashboard';
        if (role === 'admin') {
            dashboardPath = '/admin';
        }
        // Add more roles here as needed
        return <Navigate to={dashboardPath} replace />;
    }

    // If not logged in, allow access to the public route
    return children;
}